'use client'
// Composant vide — plus de sélecteur de langue (FR uniquement)
export function LangSwitch({ className = '' }: { className?: string }) {
  return null
}
